/* TATI Theme JavaScript — Evolved */
(function() {
  'use strict';

  /* === Reveal on scroll === */
  function initReveal() {
    const els = document.querySelectorAll('.reveal, .animate-on-scroll');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in', 'visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in', 'visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => observer.observe(el));
  }

  /* === Wishlist toggle on product cards === */
  function initWishlist() {
    document.querySelectorAll('.product-card__fav, .product-card__wishlist').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.toggle('active');
      });
    });
  }

  /* === Product page: variant pills + color swatches === */
  function initProductOptions() {
    document.querySelectorAll('.product__option-pill, .product__color-swatch, .size-option:not(.sold-out)').forEach(opt => {
      opt.addEventListener('click', function() {
        const siblings = this.parentElement.children;
        Array.from(siblings).forEach(s => s.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  /* === Product gallery thumbs === */
  function initGallery() {
    const main = document.getElementById('main-product-image');
    document.querySelectorAll('.product__thumb, .product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', function() {
        const siblings = this.parentElement.children;
        Array.from(siblings).forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const img = this.querySelector('img');
        if (main && img) main.src = img.src.replace(/width=\d+/, 'width=1200');
      });
    });
  }

  /* === Accordion (legacy) === */
  function initAccordions() {
    document.querySelectorAll('.accordion-trigger, .faq-trigger').forEach(trigger => {
      trigger.addEventListener('click', function() {
        const item = this.closest('.accordion-item, .faq-item');
        if (!item) return;
        const isOpen = item.classList.contains('open');
        item.parentElement?.querySelectorAll('.open').forEach(s => s.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* === Popup === */
  function initPopup() {
    const popup = document.querySelector('.popup-overlay');
    if (!popup) return;
    popup.addEventListener('click', function(e) {
      if (e.target === popup) popup.classList.remove('show', 'active');
    });
    popup.querySelectorAll('.popup__close, .popup-dismiss').forEach(btn => {
      btn.addEventListener('click', () => popup.classList.remove('show', 'active'));
    });
  }

  /* === Filter pills (visual only — links handle nav) === */
  function initFilterPills() {
    document.querySelectorAll('.filter-pill').forEach(pill => {
      if (pill.tagName === 'A') return; // anchors handle themselves
      pill.addEventListener('click', function() {
        this.parentElement.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  /* === Mobile menu === */
  function initMobileMenu() {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('.main-nav');
    if (!toggle || !nav) return;

    // Add a backdrop element
    let backdrop = document.querySelector('.mobile-menu-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'mobile-menu-backdrop';
      document.body.appendChild(backdrop);
    }

    function close() {
      nav.classList.remove('mobile-open');
      backdrop.classList.remove('show');
      document.body.style.overflow = '';
    }
    function open() {
      nav.classList.add('mobile-open');
      backdrop.classList.add('show');
      document.body.style.overflow = 'hidden';
    }

    toggle.addEventListener('click', () => {
      if (nav.classList.contains('mobile-open')) close(); else open();
    });
    backdrop.addEventListener('click', close);
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* === Quick Add to cart (product cards) === */
  // Adds a variant id to the cart, then refreshes the header count bubble.
  function addVariantToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
    .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(() => fetch('/cart.js'))
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.cart-count').forEach(c => c.setAttribute('data-count', cart.item_count));
      return cart;
    });
  }

  /* --- Quick Add popup (only used when a product has size/color options) --- */
  function ensureQuickAddModal() {
    let modal = document.getElementById('qa-modal');
    if (modal) return modal;

    // Inject styles once (reuses theme CSS variables + product option classes)
    const css = document.createElement('style');
    css.textContent = `
      .qa-overlay { position: fixed; inset: 0; background: rgba(5,51,82,.55); display: none; align-items: center; justify-content: center; z-index: 2000; padding: 20px; }
      .qa-overlay.show { display: flex; }
      .qa-card { background: var(--cream-3, #fff); border-radius: var(--radius-lg, 20px); width: 100%; max-width: 460px; max-height: 90vh; overflow: auto; position: relative; animation: qaUp .25s ease; }
      @keyframes qaUp { from { opacity: 0; transform: translateY(20px) scale(.98); } to { opacity: 1; transform: none; } }
      .qa-close { position: absolute; top: 14px; right: 14px; width: 36px; height: 36px; border-radius: 999px; border: none; background: rgba(255,255,255,.85); color: var(--navy); font-size: 22px; line-height: 1; cursor: pointer; z-index: 2; }
      .qa-media { aspect-ratio: 1/1; background: var(--cream-2); }
      .qa-media img { width: 100%; height: 100%; object-fit: cover; display: block; }
      .qa-info { padding: 26px 28px 30px; }
      .qa-collection { font-size: 11px; letter-spacing: .14em; text-transform: uppercase; color: var(--text-light); margin-bottom: 8px; }
      .qa-title { font-family: var(--serif); font-size: 26px; color: var(--navy); line-height: 1.1; margin-bottom: 10px; }
      .qa-price { font-size: 18px; color: var(--navy); margin-bottom: 22px; }
      .qa-price del { color: var(--text-light); margin-right: 8px; font-size: 15px; }
      .qa-group { margin-bottom: 20px; }
      .qa-group .product__option-pill[disabled], .qa-group .product__color-swatch[disabled] { opacity: .3; cursor: not-allowed; text-decoration: line-through; }
      .qa-add[disabled] { opacity: .5; cursor: not-allowed; }
    `;
    document.head.appendChild(css);

    modal = document.createElement('div');
    modal.id = 'qa-modal';
    modal.className = 'qa-overlay';
    modal.innerHTML = `
      <div class="qa-card" role="dialog" aria-modal="true">
        <button class="qa-close" aria-label="Close">&times;</button>
        <div class="qa-media"><img alt=""></div>
        <div class="qa-info">
          <div class="qa-collection"></div>
          <div class="qa-title"></div>
          <div class="qa-price"></div>
          <div class="qa-options"></div>
          <button type="button" class="btn btn--primary btn--block btn--lg qa-add">Add to bag</button>
        </div>
      </div>`;
    document.body.appendChild(modal);

    const close = () => { modal.classList.remove('show'); document.body.style.overflow = ''; };
    modal.querySelector('.qa-close').addEventListener('click', close);
    modal.addEventListener('click', e => { if (e.target === modal) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    return modal;
  }

  function openQuickAddModal(data) {
    const modal = ensureQuickAddModal();
    const selected = [];           // selected value per option index
    const optionNames = data.options.map(o => o.name);

    // Pre-select the first AVAILABLE variant's options
    const firstAvail = data.variants.find(v => v.available) || data.variants[0];
    if (firstAvail) firstAvail.options.forEach((val, i) => { selected[i] = val; });

    function matchVariant() {
      return data.variants.find(v => v.options.every((val, i) => val === selected[i]));
    }
    // Is there ANY available variant that has `value` at option index `idx`?
    function valueAvailable(idx, value) {
      return data.variants.some(v => v.available && v.options[idx] === value &&
        selected.every((sel, i) => i === idx || sel == null || v.options[i] === sel));
    }

    function render() {
      modal.querySelector('.qa-media img').src = data.image || '';
      modal.querySelector('.qa-collection').textContent = data.collection || '';
      modal.querySelector('.qa-title').textContent = data.title || '';

      const v = matchVariant();
      const priceEl = modal.querySelector('.qa-price');
      if (v) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price !== v.price ? '<del>' + v.compare_at_price + '</del>' : '') + v.price;
      } else {
        priceEl.textContent = '';
      }

      const wrap = modal.querySelector('.qa-options');
      wrap.innerHTML = '';
      data.options.forEach((option, idx) => {
        const group = document.createElement('div');
        group.className = 'qa-group product__option-group';
        const label = document.createElement('div');
        label.className = 'product__option-label';
        label.innerHTML = '<span>' + option.name + ': <em style="color:var(--text);font-style:normal;font-weight:400;">' + (selected[idx] || '') + '</em></span>';
        group.appendChild(label);

        const row = document.createElement('div');
        row.className = 'product__option-row';
        option.values.forEach(value => {
          const isColor = option.name.toLowerCase() === 'color';
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.dataset.value = value;
          const active = selected[idx] === value;
          const avail = valueAvailable(idx, value);
          if (isColor) {
            btn.className = 'product__color-swatch' + (active ? ' active' : '');
            btn.style.background = value.toLowerCase().replace(/\s+/g, '');
            btn.setAttribute('aria-label', value);
          } else {
            btn.className = 'product__option-pill' + (active ? ' active' : '');
            btn.textContent = value;
          }
          if (!avail) btn.disabled = true;
          btn.addEventListener('click', () => { selected[idx] = value; render(); });
          row.appendChild(btn);
        });
        group.appendChild(row);
        wrap.appendChild(group);
      });

      const addBtn = modal.querySelector('.qa-add');
      const valid = v && v.available;
      addBtn.disabled = !valid;
      addBtn.textContent = v ? (v.available ? 'Add to bag — ' + v.price : 'Sold out') : 'Select options';
      addBtn.onclick = valid ? function () {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        addVariantToCart(v.id)
          .then(() => {
            addBtn.textContent = '✓ Added to bag';
            setTimeout(() => { modal.classList.remove('show'); document.body.style.overflow = ''; }, 800);
          })
          .catch(() => { addBtn.disabled = false; addBtn.textContent = 'Try again'; });
      } : null;
    }

    render();
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function initQuickAdd() {
    document.querySelectorAll('.product-card__quick').forEach(btn => {
      btn.addEventListener('click', function(e) {
        // Button lives inside the card <a> — stop the link from navigating
        e.preventDefault();
        e.stopPropagation();
        if (this.classList.contains('is-loading')) return;

        const hasOptions = this.getAttribute('data-has-options') === 'true';

        // Product has size/color choices → open the picker popup
        if (hasOptions) {
          const dataEl = this.closest('.product-card')?.querySelector('.quick-add-data');
          if (dataEl) {
            try { openQuickAddModal(JSON.parse(dataEl.textContent)); return; }
            catch (err) { /* fall through to direct add */ }
          }
        }

        // Simple product → add the (only) variant instantly
        const variantId = this.getAttribute('data-product-id');
        if (!variantId) return;
        const original = this.textContent;
        this.classList.add('is-loading');
        this.textContent = 'Adding…';
        addVariantToCart(variantId)
          .then(() => {
            this.textContent = '✓ Added';
            setTimeout(() => { this.textContent = original; this.classList.remove('is-loading'); }, 1500);
          })
          .catch(() => {
            this.textContent = 'Try again';
            setTimeout(() => { this.textContent = original; this.classList.remove('is-loading'); }, 1500);
          });
      });
    });
  }

  /* === Bundle Builder + Frequency (legacy support) === */
  function initBundleBuilder() {
    document.querySelectorAll('.bundle-item').forEach(item => {
      item.addEventListener('click', () => item.classList.toggle('selected'));
    });
    document.querySelectorAll('.freq-option').forEach(opt => {
      opt.addEventListener('click', function() {
        this.parentElement.querySelectorAll('.freq-option').forEach(o => o.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initWishlist();
    initProductOptions();
    initGallery();
    initAccordions();
    initPopup();
    initFilterPills();
    initMobileMenu();
    initQuickAdd();
    initBundleBuilder();
  });
})();
